import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#383838"
      d="M12.49 18H5.512A5.518 5.518 0 0 1 0 12.49V5.512A5.515 5.515 0 0 1 5.51 0h6.979A5.518 5.518 0 0 1 18 5.51v6.978a5.518 5.518 0 0 1-5.511 5.51l.002.002ZM5.51 1.348a4.17 4.17 0 0 0-4.166 4.164v6.978a4.17 4.17 0 0 0 4.165 4.164h6.98a4.17 4.17 0 0 0 4.165-4.164V5.512a4.17 4.17 0 0 0-4.165-4.164h-6.98Z"
    />
    <path
      fill="#383838"
      d="M9 14c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5Zm0-8.486A3.489 3.489 0 0 0 5.514 9 3.489 3.489 0 0 0 9 12.486 3.489 3.489 0 0 0 12.486 9 3.489 3.489 0 0 0 9 5.514ZM15 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    />
  </svg>
)
export default SvgComponent
